export default {
	"route.dashboard": "Datenberichte",
	"route.robot": "Roboter",
	"route.robotList": "Liste der Roboter",
	"route.groupManage": "Management der Gruppe",
	"route.disinfect": "Aufgabe",
	"route.home": "Hauptseite",
	"route.disinfectTask": "Aufgabe",
	"route.building": "Gebäude",
	"route.accessControl": "Zugangskontrolle",
	"route.ladderControl": "Aufzugskontrolle",
	"route.IOT": "IdD",
	"route.accounts": "Konto",
	"route.roles": "Rolle",
	"route.jurisdiction": "Berechtigung",
	"route.dispatcher": "Verteiler ",
	"navbar.logOut": "Abmelden",
	"login.title": "Anmeldung mit Unternehmens-ID",
	"login.logIn": "anmelden",
	"login.username": "Konto",
	"login.tip_username": "Bitte den Benutzernamen eingeben",
	"login.password": "Passwort",
	"login.company_id": "Unternehmens-ID",
	"login.tip_company": "Unternehmens-ID eingeben",
	"login.tip_pwd": "Passwort eingeben",
	"robot.projectTtitle": "Roboter-Management-Plattform",
	"robot.manage": "Roboter-Management",
	"system.search": "Suchen",
	"system.reset": "Zurücksetzen",
	"system.open": "Entfalten",
	"system.retract": "Falten",
	"system.status": "Status",
	"system.inProgress": "In Bearbeitung",
	"system.normalCompletion": "Fertig",
	"system.abnormalEnd": "Abnormales Ende",
	"system.noData": "Keine Daten",
	"universality.confirm": "Bestätigen",
	"universality.cancel": "Absagen",
	"universality.Pleasedonot": "Bitte nicht leer eingeben",
	"universality.Pleaseifsymbols": "Bitte 6-20 Ziffern eingeben, Englisch, Sonderzeichen",
	"disinfect.robotremarkname": "Bemerkung des Roboters",
	"disinfect.EnterNoteName": "Bemerkung eingeben",
	"disinfect.robotSerialNumber": "Seriennummer des Roboters",
	"disinfect.inputSequenceNumber": "Seriennummer eingeben",
	"disinfect.selectStatus": "Status auswählen",
	"disinfect.destination": "Ziel",
	"disinfect.Enterdestination": "Zielort eingeben",
	"disinfect.dates": "Datum",
	"disinfect.tos": "bis",
	"disinfect.startDates": "Startdatum",
	"disinfect.endDates": "Enddatum",
	"disinfect.starttimes": "Anfangszeit",
	"disinfect.endtimes": "Endzeit",
	"disinfect.Lastweek": "Letzte Woche",
	"disinfect.Lastmonth": "Letzter Monat",
	"disinfect.Lastthreemonths": "Letzte drei Monate",
	"disinfect.nonExecution": "Nicht durchgeführt",
	"disinfect.canceled": "absagen",
	"disinfect.UnclaimedProperty": "Niemand holt die Mahlzeiten ab",
	"disinfect.hardwareFailure": "Hardware-Fehler",
	"disinfect.NavigationFault": "Navigation-Fehler",
	"disinfect.Manualcancellation": "Manuell abbrechen",
	"navigationBar.logout": "Abmelden",
	"navigationBar.logoutandsystem": "Konto und System abmelden?",
	"account.userlist": "Benutzer-Liste",
	"account.searchnames": "Suchen",
	"account.adduser": "Konto hinzufügen",
	"account.user": "Konto",
	"account.roles": "Rolle",
	"account.ResponsibleRobot": "Roboter im Betrieb",
	"account.name": "Name",
	"account.remark": "Bemerkung",
	"account.Recentloginiof": "Letzte Anmeldedaten",
	"account.operation": "Operation",
	"account.compile": "Bearbeiten",
	"account.resetpasswords": "Das Passwort zurücksetzen",
	"account.delete": "Löschen",
	"account.pleaseuserpasnumb": "6-20 Ziffern, Englisch, Zahlen, Sonderzeichen",
	"account.pleasepasswordnumb": "Passwort eingeben (6-20 Ziffern, Englisch, Zahlen, Sonderzeichen)",
	"account.selectroles": "Rolle auswählen",
	"account.selectbuild": "Gebäude auswählen",
	"account.inputnames": "Bitte den Benutzernamen eingeben",
	"account.inputremarks": "Bitte Bemerkungen eingeben",
	"account.userdetail": "Details zum Konto",
	"account.platform": "Stück",
	"account.noBindingRobot": "Derzeit kein verbindlicher Roboter",
	"account.addtimes": "Uhrzeit hinzufügen",
	"account.LastonlineTime": "Letzte Anmeldezeit",
	"account.Resetsuccessfully": "Zurücksetzen erfolgreich",
	"account.initialPassword": "Erstes Passwort",
	"account.gotIt": "Verstanden",
	"account.PleaseRoles": "Rolle auswählen",
	"account.Pleasebuilds": "Gebäude auswählen",
	"account.PleaseRobots": "Roboter auswählen",
	"account.compileusers": "Konto bearbeiten",
	"account.deleteusers": "Konto löschen",
	"account.Unabletologinafterdeleting": "Nach dem Löschen des Kontos kann ich mich nicht anmelden, bitte bestätigen ",
	"account.alreadyexistsConfirmpasswords": "Das Passwort auf das erste Passwort zurücksetzen?",
	"account.alreadyExists": "Das Konto ist bereits vorhanden.",
	"map.deleteThecloudmap": "Wenn Sie Cloud-Map löschen, werden gleichzeitig alle mit dem Roboter verbundenen Karten gelöscht. Sind Sie sicher?",
	"map.deletemaps": "Karte löschen",
	"homes.robotTotal": "Gesamtzahl der Roboter (Stück)",
	"homes.tasksTotal": "Gesamtzahl der kumulativen Aufgaben",
	"homes.onlineTimeTotal": "Gesammelte Online-Stunden",
	"homes.nearly-7-days-onlineTime": "Die Entwicklung der Online-Stunden in den letzten 7 Tagen",
	"homes.cumulativeMileage": "Kumulierter Kilometerstand (Meter)",
	"homes.robotWorkingHoursData": "Die Daten der Roboterarbeitszeit",
	"homes.trendWorkingHours": "The trend of working hours",
	"homes.explain": "Bemerkung",
	"homes.explainContent": "Daten über Roboterlieferungen in verschiedenen Gebäuden sammeln",
	"homes.to": "Bis",
	"homes.startTime": "Startzeit",
	"homes.endTime": "Endezeit",
	"homes.proportionWorkingHours": "Anteil der Arbeitsstunden",
	"homes.buildingDeliveryList": "Rangfolge der Lieferzeiten für Gebäude",
	"public.second": "Mal",
	"public.rice": "Meter",
	"public.lastSevenDays": "Letzte 7 Tage",
	"public.lastFourteenDays": "Letzte 14 Tage",
	"public.lastThirtyDays": "Letzte 30 Tage",
	"robotState.notActive": "Nicht aktiviert",
	"robotState.abnormalEnd": "Abnormales Ende",
	"robotState.hasLeft": "Verlassen",
	"robotState.online": "Online",
	"robotState.offline": "Offline",
	"robotState.charge": "Aufladen",
	"robotState.unknown": "Unbekannt",
	"robotState.atWork": "Im Betrieb",
	"robotState.free": "Unbestellt",
	"robotState.unexecuted": "Unausgeführte",
	"robotState.executing": "In Bearbeitung",
	"robotState.canceled": "Abgebrochen",
	"robotState.Completed": "Abgeschlossen",
	"robotState.nobodyTakesThings": "Niemand holt die Mahlzeiten ab",
	"robot.robotList": "Liste der Roboter",
	"robot.buildings": "Gebäude",
	"robot.selectBuilding": "Gebäude auswählen",
	"robot.search": "Bemerkung und Seriennummer suchen",
	"robot.notAddRobot": "Kein Roboter hinzugefügt oder aktiviert",
	"robot.mileage": "Kumulierter Kilometerstand",
	"robot.information": "Grundlegende Informationen",
	"robot.noteName": "Bemerkung",
	"robot.model": "Modus",
	"robot.onlineStatus": "Online Status",
	"robot.workingStatus": "Arbeitsstand",
	"robot.currentPower": "Aktuelle Leistung",
	"robot.serialNumber": "Seriennummer",
	"robot.operationData": "Betriebsdaten",
	"robot.latestOnlineTime": "Zuletzt online",
	"robot.cumulativeOnlineDuration": "Kumulierte Online-Stunden",
	"robot.cumulativeDeliveryTimes": "Kumulative Anzahl der Lieferungen",
	"robot.cumulative-delivery-time": "Kumulierte Lieferstunden",
	"robot.cumulativeLeadTime": "Kumulative Begleitungszeiten",
	"robot.System-Hardware": "Systeme und Hardware",
	"robot.systemVersion": "Systemversion",
	"robot.hardwareStatus": "Hardware-Status",
	"robot.language": "Systemsprache",
	"robot.voice_pack": "Sprachpakete",
	"robot.box_model": "Kabinett",
	"robot.android_soft": "Android software",
	"robot.android_mirror": "Android-Spiegel",
	"robot.header_control": "Kopf-Bedienfeld",
	"robot.under_panel_version": "Fahrgestell-Version",
	"robot.under_mirror": "Fahrgestellspiegel",
	"robot.under_master": "Fahrwerk-Mastersteuerung",
	"robot.under_control": "Fahrgestell-Bedienfeld",
	"robot.rgbd_up": "RGBD (oben)",
	"robot.rgbd_down": "RGBD (unten)",
	"robot.doorControlMotor": "Motor der Türsteuerung",
	"robot.frontMountedCamera": "Front-Kamera",
	"robot.overheadCamera": "Obere Kamera",
	"robot.infraredDetectionBox": "Infrarot-Detektion ",
	"robot.microphone": "Mikrfon",
	"robot.radar": "Lidar",
	"robot.head-RGBD": "RGBD (oben)",
	"robot.bottom-RGBD": "RGBD (unten)",
	"robot.ultrasonicSensor": "Ultraschallsensor",
	"robot.IMU": "IMU",
	"robot.hubMotor": "Nabenmotor",
	"robot.emergencyStopSwitch": "Not-Aus-Schalter",
	"robot.horn": "Lautsprecher",
	"robot.getFailed": "Zugang fehlgeschlagen",
	"robot.normal": "Normal",
	"robot.abnormal": "Abnormal",
	"robot.cancel": "Löschen",
	"robot.confirm": "Bestätigen",
	"public.noteNameCannotBeEmpty": "Die Bemerkung kann nicht leer sein",
	"public.layer": "Etage",
	"public.door": "Gebäude",
	"public.rename": "umbenennen",
	"public.delete": "Löschen",
	"robot.percentageTasksCompletedTotal": "Der Prozentsatz der erledigten kumulativen Aufgaben",
	"robotState.workSuspension": "Aufgabe unterbrochen",
	"buiding.buildingList": "Liste der Gebäude",
	"buiding.add": "Hinzufügen",
	"buiding.addFloors": "Etage hinzufügen",
	"buiding.pleaseCompleteBuidingsData": "Bitte vervollständigen Sie die Gebäudedaten in der Liste auf der linken Seite!",
	"buiding.map": "Karte",
	"buiding.source": "Quelle",
	"buiding.uploadTime": "Zeit zum Hochladen",
	"buiding.pleaseRobotUploadMap": "Bitte laden Sie die Karte in den Roboter hoch",
	"buiding.associatedBuildings": "Verbundene Gebäude",
	"buiding.robot": "Roboter",
	"buiding.associatedRobot": "Roboter verbinden",
	"buiding.associatedShop": "Verbundener Laden",
	"buiding.type": "Typ",
	"buiding.pleaseType": "Bitte den Typ wählen ",
	"buiding.buildingName": "Name des Gebäudes",
	"buiding.pleaseBuildingName": "Bitte geben Sie den Gebäudenamen ein",
	"buiding.shopName": "Name des Ladens",
	"buiding.pleaseShopName": "Bitte geben Sie den Namen des Ladens ein",
	"buiding.floor": "Etage",
	"buiding.floorName": "Name der Etage",
	"buiding.pleaseFloorName": "Name der Etage.",
	"buiding.floorNameBeEmpty": "Der Etagenname darf nicht leer sein",
	"buiding.buid": "Gebäude",
	"buiding.shop": "Laden",
	"buiding.serialNumberCannotBeEmpty": "Die Seriennummer darf nicht leer sein",
	"buiding.buildingAdd": "Gebäude hinzufügen",
	"buiding.pleaseBuilsdingName": "Bitte geben Sie den Gebäudenamen ein",
	"buiding.buildingsNameBeEmpty": "Der Gebäudename kann nicht leer sein.",
	"buiding.AreYouSureToDeleteThisFloor": "Sind Sie sicher, die Etage zu löschen?",
	"buiding.deleteFloor": "Etage löschen",
	"buiding.AreYouSureToDeleteThisShop": "Sind Sie sicher, den Laden zu löschen?",
	"buiding.deleteShop": "Laden löschen",
	"buiding.AreYouSureToDeleteThisBuilding": "Sind Sie sicher, die Gebäude zu löschen?",
	"buiding.deleteBuilding": "Gebäude löschen",
	"buiding.editBuilding": "Gebäude bearbeiten",
	"buiding.editFloor": "Etage bearbeiten",
	"buiding.editShop": "Laden bearbeiten",
	"buiding.shopNameAlreadyExists": "Der Name des Ladens ist bereits vorhanden",
	"buiding.shopAddSuccess": "Der Laden ist hinzugefügt.",
	"buiding.floorNameAlreadyExists": "Der Etagename ist bereits vorhanden.",
	"buiding.floorAddSuccess": "Etage hizugefügt",
	"buiding.buildingNameAlreadyExists": "Gebäudename",
	"buiding.buildingAddSuccess": "Gebäude hinzugefügt",
	"buiding.shopEditSuccess": "Der Laden wurde erfolgreich bearbeitet.",
	"buiding.buildingEditSuccess": "Die Gebäude wurde erfolgreich bearbeitet.",
	"buiding.floorEditSuccess": "Die Etage wurde erfolgreich bearbeitet.",
	"buiding.selectRobot": "Einen Roboter auswählen",
	"buiding.replacementBuildings": "Wechsel zu einem anderen Gebäude",
	"role.rolelist": "Rollenliste",
	"role.addroles": "Eine Rolle hinzufügen",
	"role.names": "Name",
	"role.Entername": "Name eingeben",
	"role.PleaseEntername": "Name eingeben",
	"role.editroles": "Rolle bearbeiten",
	"role.deleteroles": "Rolle löschen",
	"role.Confirmdeletion": "Gelöschte Rolle kann nicht wiederhergestellt werden, sicher?",
	"role.nameAlreadyExists": "Die Rolle ist bereits vorhanden. ",
	"navigationBar.personalInfo": "Persönliche Daten",
	"navigationBar.changePassword": "Passwort ändern",
	"navigationBar.administrator": "Administrator",
	"navigationBar.domesticConsumer": "Allgemeiner Benutzer",
	"navigationBar.originalPsd": "Ursprüngliches Passwort",
	"navigationBar.EnterOriginalPsd": "Ursprüngliches Passwort eingeben ",
	"navigationBar.newPassword": "Neues Passwort",
	"navigationBar.confirmPassword": "Bestätigen Sie Ihr Passwort",
	"navigationBar.EntertheNewPsdAga": "Geben Sie das neue Passwort erneut ein",
	"navigationBar.TheOriPsdCannotEmpty": "Ursprüngliches Passwort kann nicht leer sein. ",
	"navigationBar.TheNewPsdempty": "Neues Passwort kann nicht leer sein",
	"navigationBar.PleEntertheNewPsdAga": "Bitte geben Sie das neue Passwort erneut ein",
	"navigationBar.TheNewPasastheoldone": "Das neue Passwort ist dasselbe wie das alte",
	"navigationBar.Psdisinconsistentwith": "Die beiden Passwörter sind unterschiedlich. Bitte bestätigen Sie.",
	"navigationBar.modifySuccessfully": "Ändern erfolgreich",
	"accessControl.accessControlList": "Liste der Zugangskontrolle",
	"accessControl.floor": "Etage ",
	"accessControl.accessControlAdd": "Zugangskontrolle hinzufügen",
	"accessControl.accessControlID": "Zugangskontrolle ID",
	"accessControl.selectAccessControlID": "Zugangskontrolle auswählen",
	"accessControl.accessControlID-Hint": "Der Zugangskontrolldienst wird bestätigt. Der Kunde hat die Zugangskontroll-ID bereits konfiguriert.",
	"accessControl.label": "Bermerkung Name",
	"accessControl.pleaseLabel": "Bermerkung Name eingeben",
	"accessControl.deleteAccessControl-Hint": "Das Löschen der Zugangskontrolle führt dazu, dass der Roboter nicht türübergreifende Aufgaben auszuführen kann, sicher?",
	"accessControl.deleteAccessControl": "Zugangskontrolle löschen",
	"accessControl.editAccessControl": "Zugangskontrolle bearbeiten",
	"accessControl.accessControlIdExists": "Zugangskontrolle ID ",
	"public.notAssociatedFloor": "Nicht mit der Etage verbunden",
	"public.notAssociatedBuilding": "Nicht mit der Gebäude verbunden",
	"public.all": "Alle",
	"public.rules.pleaseLabel": "Bitte geben Sie die Bemerkung ein",
	"dispatcher.dispatcherList": "Verteilerliste",
	"dispatcher.searchName": "Suche nach Name",
	"buiding.deleteShopTips": "Bitte heben Sie zunächst die Verknüpfung aller Daten (Roboter/Karten) des Ladens auf.",
	"buiding.deleteBuidingTips": "Bitte heben Sie zunächst die Verknüpfung aller Daten (Roboter/Karten) der Gebäude auf.",
	"buiding.deleteFloorTips": "Bitte heben Sie zunächst die Verknüpfung aller Daten (Roboter/Karten) der Etage auf.",
	"ladderControl.ladderControlList": "Liste der Aufzugskontrolle",
	"ladderControl.addLadderControl": "Eine Aufzugkontrolle hinzufügen",
	"ladderControl.grouping": "Gruppierung",
	"ladderControl.Buildings": "Gebäude",
	"ladderControl.You-can-go-to-the-floor": "Zugängliche Etagen",
	"ladderControl.pleaseGoToBuilding": "Bitte gehen Sie zum Gebäude und verschaffen Sie sich Zugang zur Aufzugskontrolle",
	"ladderControl.grouping-tips-1": "Die Gruppierung wird zur Unterscheidung verschiedener Aufzugsrufpunkte verwendet",
	"ladderControl.grouping-tips-2": "1. Für die Situation mit nur einem Aufzug oder mehreren Aufzügen auf derselben Etage können Sie die Standardgruppe auswählen",
	"ladderControl.grouping-tips-3": "2. Aufzüge auf verschiedenen Etagen und Wartehallen müssen in Gruppen eingeteilt werden",
	"public.common": "Gebäude",
	"ladderControl.ladderControlID": "Aufzugskontroll-ID ",
	"ladderControl.selectLadderControlID": "Aufzugskontroll-ID auswählen",
	"ladderControl.ladderControlID-tips": "Bitte überprüfen Sie mit der Aufzug-/Zugangskontrolle, ob der Kunde eine konfigurierte Aufzugskennung hat.",
	"ladderControl.groupingPlaceholder": "Eingabe oder Auswahl einer Gruppe (z. B. Hochhausaufzüge)",
	"ladderControl.deleteladderControl": "Aufzugskontroll löschen",
	"ladderControl.deleteladderControl-tips": "Das Löschen der Zugangskontrolle führt dazu, dass der Roboter nicht Etageübergreifende Aufgaben auszuführen kann, sicher?",
	"ladderControl.ladderControlIdExists": "Die Aufzugskontroll-ID ist bereits vorhanden",
	"login.remTheNub": "Das Passwort merken",
	"login.oldPasswordError": "Das alte Passwort ist falsch",
	"login.confirmAndNewParrword": "Die beiden Passwörter sind nicht identisch",
	"robot.advertising": "Anzeige",
	"homes.buildingDeliveryTimes": "Lieferzeiten",
	"robot.detail": "Roboterdetails",
	"robot.robotModel": "Robotertyp",
	"robot.header_control-2": "Android-Powerboard",
	"robot.under_mirror-2": "Gehäuse-ROM",
	"robot.under_master-2": "Fahrgestell-Hauptsteuerung",
	"robot.under_control-2": "Chassis-Leistungsplatine",
	"robot.nav": "Navigationsalgorithmus",
	"robot.up_rgbd": "Top-RGBD",
	"robot.down_rgbd": "Unten RGBD",
	"robot.camera": "Top Kamera",
	"robot.ss": "Vordere Kamera",
	"robot.rgbd_top_depth": "Top RGBD-Tiefe",
	"robot.rgbd_top_color": "Top RGBD-Farbe",
	"robot.rgbd_bottom_depth": "Untere RGBD-Tiefe",
	"robot.rgbd_bottom_color": "Unten RGBD-Farbe",
	"robot.ultrasonic1": "Ultraschall links",
	"robot.ultrasonic2": "Richtiger Ultraschall",
	"robot.motor1": "Linker Motor",
	"robot.motor2": "Richtiger Motor",
	"robot.detection": "Objekterkennung",
	"buiding.builNameAlreadyExists": "Gebäudename existiert bereits",
	"robot.bindingSuccess": "Erfolgreich binden",
	"robot.notActive": "Nicht aktiviert",
	"robotinfo.logdown": "Herunterladen von Protokollen",
	"robotinfo.Logtype": "Protokolltyp",
	"robotinfo.displayboard": "Anzeigetafel",
	"robotinfo.maincontrolpanel": "Hauptsteuerplatine",
	"robotinfo.powerstrip": "Leistungsplatine",
	"robotinfo.navigationdata": "Navigationsdaten",
	"robotinfo.Plethedate": "Bitte wählen Sie ein Datum",
	"robotinfo.Plethetime": "Bitte wählen Sie eine Zeit aus",
	"robotinfo.acquire": "Herunterladen",
	"robotinfo.Packinglog": "Protokolle verpacken",
	"robotinfo.Uploadinglogfiles": "Protokolldatei wird hochgeladen",
	"robotinfo.Gettinguploadstatus": "Upload-Status abrufen",
	"robotinfo.acquiresuccess": "Werde erfolgreich",
	"robotinfo.clicktodownload": "Klicken Sie hier zum Herunterladen",
	"robotinfo.Plelogtype": "Bitte wählen Sie einen Protokolltyp aus",
	"robotinfo.Plestartdateandtime": "Bitte wählen Sie ein Startdatum und eine Uhrzeit aus",
	"robotinfo.Pleanenddateandtime": "Bitte wählen Sie ein Enddatum und eine Uhrzeit aus",
	"robotinfo.Nologtime": "Keine Protokolle für diesen Zeitraum",
	"robotinfo.logtaskispackagedpackged": "Der Roboter verpackt oder lädt gerade Protokolle hoch",
	"robotinfo.failtoget": "Fehler beim Abrufen",
	"robotinfo.Failedtopackage1/2": "Verpackung 1/2 fehlgeschlagen",
	"robotinfo.Failedtopackage2/2": "Verpackung 2/2 fehlgeschlagen",
	"robotinfo.failtoupload": "Upload fehlgeschlagen",
	"public.unrelatedBuildings": "Nicht mit dem Gebäude verbunden",
	"buiding.sameFloorNumber": "Die gleiche Stockwerksnummer existiert bereits in diesem Gebäude",
	"navigationBar.pleaseEnterOriginalPsd": "Bitte geben Sie das ursprüngliche Passwort ein",
	"navigationBar.newpassword": "Geben Sie ein neues Passwort ein (bitte 6-20 Ziffern, Englisch, Symbole eingeben)",
	"navigationBar.pleaseNewpassword": "Bitte geben Sie ein neues Passwort ein",
	"login.nnterprise-number-error": "Enterprise-ID-Fehler",
	"home.Fullrobot": "Alles Roboter",
	"map.displaytext": "Text anzeigen",
	"map.nonetext": "Text nicht anzeigen",
	"robot.detection-1": "Objekterkennung 1",
	"robot.detection-2": "Objekterkennung 2",
	"robot.detection-3": "Objekterkennung 3",
	"robot.detection-4": "Objekterkennung 4",
	"robot.current_systemVersion": "Aktuelle Version",
	"robot.cumulativeTimes": "Lieferzeiten",
	"robot.cumulativeTime": "Lieferzeit",
	"home.hour": "Stunden",
	"home.min": "Minuten",
	"home.deliverytimes": "Lieferzeiten (Zeiten)",
	"login.actpaswdinco": "Benutzername oder Passwort falsch",
	"login.enterpriseerror": "Enterprise-ID-Fehler",
	"home.numberofworkmachs": "Anzahl der Arbeitsroboter",
	"home.workinghours": "Arbeitszeit",
	"login.account_expired": "Konto ist abgelaufen, bitte melden Sie sich erneut an",
	"robot.CADEBOT_rankingList_tips": "Rangliste der Zielzustellung",
	"robot.setLabel": "Bemerkung erfolgreich gesetzt",
	"homes.nearly-7-days-mileage": "Laufleistungstrend in den letzten 7 Tagen",
	"robot.robotisofflineobtalogs": "Roboter ist offline, Protokolle können nicht abgerufen werden",
	"buiding.buid-illustrate": "Gebäude (für mehrere Stockwerke)",
	"buiding.shop-illustrate": "Laden (für ein Stockwerk)",
	"buiding.new-pleaseFloorName": "Bitte geben Sie den Namen der Etage ein",
	"route.admage": "Werbung",
	"route.asset": "Ressourcenbibliothek",
	"route.ads": "Anzeigenfreigabe",
	"route.adsDetail": "Anzeigen-Details",
	"route.addAds": "Anzeige hinzufügen",
	"route.editAds": "Anzeige bearbeiten",
	"ad.asset": "Ressourcenliste",
	"ad.freeSpace": "Verbeleibender Speicherplatz",
	"ad.uploadAsset": "Ressourcen hochladen",
	"ad.filename": "Name der Datei",
	"ad.type": "Typ",
	"ad.memory": "Speicher",
	"ad.video": "Video",
	"ad.image": "Bild",
	"ad.uploadTime": "Upload-Zeit",
	"ad.uploadProgress": "Fortschritt des Uploads",
	"ad.uploadSuccess": "Upload erfolgreich",
	"ad.operation": "Vorgang",
	"ad.check": "Ansicht",
	"ad.delete": "Löschen",
	"ad.confirm": "Bestätigen",
	"ad.cancel": "Absagen",
	"ad.deleteSuccess": "Erfolgreich gelöscht",
	"ad.back": "Zurück",
	"ad.deleteAsset": "Gelöschte Ressourcen",
	"ad.deleteAssetWarningMessage": "Gelöschte Ressourcen werden nicht wiederhergestellt, bestätigen Sie die Löschung?",
	"ad.extLimit": "Es können nur Dateien in den Formaten JPG, PNG, MP4, AVI, MOV, WMV, RMVB hochgeladen werden.",
	"ad.sizeLimit": "Eine einzelne Datei darf 1 GB nicht überschreiten.",
	"ad.syncFail": "Herunterladen fehlgeschlagen",
	"ad.syncComplete": "Herunterladen abgeschlossen",
	"ad.downloadComplete": "Konfiguration in Bearbeitung",
	"ad.downloadWaiting": "Nicht heruntergeladen",
	"ad.name": "Name",
	"ad.playTime": "Zeitspanne der Anzeige",
	"ad.materialNum": "Anzahl der Ressourcen",
	"ad.robotNum": "Anzahl der besetzten Roboter",
	"ad.startTime": "Zeit der Veröffentlichung",
	"ad.addSchema": "Anzeige hinzufügen",
	"ad.copySchema": "Plan kopieren",
	"ad.edit": "Bearbeiten",
	"ad.publish": "veröffentlichen",
	"ad.deleteDraft": "Plan löschen",
	"ad.save": "Speichern",
	"ad.preview": "Vorschau",
	"ad.setDefault": "Jetzt verwenden",
	"ad.setDefaultPlease": "Bitte einstellen, wenn Standard",
	"ad.yes": "Ja",
	"ad.no": "Nein",
	"ad.deleteDraftWarningMessage": "Bestätigen Sie die Löschung des Programms?",
	"ad.draft": "Nicht veröffentlicht",
	"ad.schemaDetail": "Details zum Plan",
	"ad.schemaContent": "Inhalt des Plans",
	"ad.syncRecord": "Synchronisierte Aufzeichnung",
	"ad.robotSn": "Roboter fallen lassen",
	"ad.robotSelect": "Roboter auswählen",
	"ad.nameInput": "Geben Sie den Namen des Plans ein",
	"ad.robotSelectPlease": "Bitte Roboter auswählen",
	"ad.nameInputPlease": "Bitte geben Sie einen Plannamen ein",
	"ad.materialList": "Ressourcenliste",
	"ad.materialListDescriptions": "Abmessungen des Werbebildschirms: 1080 * 1920. Ziehen Sie die Karten, um die Reihenfolge anzupassen.",
	"ad.setting": "Einstellungen für die Anzeigenplatzierung",
	"ad.period": "Zeitspanne",
	"ad.allDay": "Den ganzen Tag",
	"ad.someTime": "Zeitraum",
	"ad.beginTime": "Startzeit",
	"ad.endTime": "Endzeit",
	"ad.materialLib": "Ressourcenbibliothek",
	"ad.materialNumber": "Anzahl der Ressourcen",
	"ad.removeScreen": "Geteilten Bildschirm löschen",
	"ad.removeScreenConfirm": "Bestätigen Sie das Löschen des geteilten Bildschirms?",
	"ad.playTimeDuration": "Dauer der Anzeige",
	"ad.picturePlayTime": "Dauer der Bildwiedergabe",
	"ad.addPeriod": "Zeitfenster hinzufügen",
	"ad.addPeriodLimit": "Sie können 6 verschiedene Zeitfenstern hinzufügen",
	"ad.totalTime": "Gesamtdauer",
	"ad.saveSuccess": "Erfolgreich gespeichert",
	"ad.publishSuccess": "Erfolgreich veröffentlicht",
	"ad.addPeriodFail": "Es gibt bereits ein ganztägiges Zeitfenster, kann nicht hinzugefügt werden",
	"ad.publishFail": "Veröffentlichung fehlgeschlagen",
	"ad.playTimeNoEmpty": "Spielzeit kann nicht leer gelassen werden",
	"ad.materialListNoEmpty": "Geteilter Bildschirm kann nicht leer gelassen werden",
	"ad.robot": "Roboter",
	"ad.robotOffline": "Roboter offline",
	"ad.robotOfflineAndCanNotLaunch": "Die folgenden Roboter sind offline und können nicht platziert werden",
	"ad.robotUplineOrSaveDraft": "Bitte betreiben Sie den Roboter online, oder speichern Sie den Plan zunächst als Entwurf.",
	"ad.syncStatus": "Roboter-Download-Status",
	"ad.reSync": "Neu veröffentlichen",
	"ad.goBackList": "Zurück zur Liste",
	"ad.confirmPublish": "Sind Sie sicher, dass Sie veröffentlichen möchten?",
	"ad.robotOfflineToConfirmPublish": "Der folgende Roboter ist offline, können Sie die Veröffentlichung bestätigen?",
	"ad.addCancelConfirm": "Möchten Sie bestätigen, dass der aktuelle Inhalt nach der Rückkehr nicht gespeichert wird?",
	"ad.refresh": "aktualisieren",
	"ad.publishTime": "Uhrzeit der Veröffentlichung",
	"ad.lastModifyTime": "Zeit der letzten Änderung",
	"ad.publisher": "Veröffentlicht von",
	"ad.editor": "Geändert von",
	"ad.timeOverlap": "Die Wiedergabezeiträume dürfen sich nicht überschneiden, bitte überprüfen Sie",
	"ad.endTimeMustLargerThanStartTime": "Die Endzeit des Abspielzeitraums muss größer sein als die Startzeit",
	"ad.cannotDeleteAssetUsed": "Dieser Clip wurde referenziert und kann nicht gelöscht werden.",
	"ad.deletePeriodWarningMessage": "Möchten Sie die Löschung von Zeitfenstern bestätigen?",
	"ad.complete": "Erledigt",
	"ad.fail": "Fehlgeschlagen",
	"ad.nameInputIllegal": "Der Name des Plans darf keine Sonderzeichen enthalten",
	"ad.nameDuplicate": "Der Name des Plans existiert bereits",
	"ad.updateTime": "Letzte Änderungszeit",
	"role.TherolesDeletingfails": "Die Rolle ist an ein Konto gebunden, Löschung fehlgeschlagen",
	"account.Changeofauthority": "Berechtigungsänderung",
	"account.ThepermisschgePleaseagain": "Die Berechtigung für dieses Konto wurde geändert",
	"disinfect.Unknowncause": "Kein Grund bekannt",
	"robot.accumulatedTaskExecutionTimes": "Kumulative Anzahl der durchgeführten Aufgaben",
	"home.minute": "Minuten",
	"homes.Statisticstasks": "Statistik der durchgeführten Aufgaben (in Bearbeitung)",
	"disinfect.Initilizati": "Initialisierung fehlgeschlagen",
	"disinfect.Failedtogetlocation": "Standort nicht gefunden",
	"disinfect.pointisoffthemap": "Der Zielpunkt liegt außerhalb der Karte",
	"disinfect.onastaticobstacle": "Der Zielpunkt liegt auf einem statischen Hindernis",
	"disinfect.therearenoroadsonthestaticmap": "Es gibt kein Weg auf der statischen Karte",
	"disinfect.Startingpointobstacle": "Am Start steht ein Hindernis",
	"disinfect.Lossoflocation": "Standort verloren",
	"disinfect.Failedtolocatethelostlocalpath": "Teilpfadplanung fehlgeschlagen",
	"disinfect.Clifftriggercancellation": "Cliff löst den Abbruch der Aufgabe aus",
	"disinfect.Emergencystoptriggerscancellation": "Not-Aus löst Aufhebung aus",
	"disinfect.Collisionbartriggercancel": "Antikollisionsstreifen löst Aufhebung aus",
	"disinfect.overtime": "Auszeit",
	"disinfect.Chargingpiledetectionfailed": "Erkennung der Ladestation fehlgeschlagen",
	"disinfect.Pilefailure": "Stapeln fehlgeschlagen",
	"disinfect.GlobalpathplanningfailedProcedure": "Die globale Pfadplanung ist fehlgeschlagen",
	"disinfect.Slopetriggercancellation": "Abbruch des Slope-Triggers",
	"disinfect.NavigationrecoverybeProcedure": "Wiederherstellung der Navigation fehlgeschlagen",
	"disinfect.Navigateoutnarrowchannel": "Enger Pfad ist blockiert",
	"disinfect.Androidtasktimeout": "Zeitüberschreitung der Aufgabe",
	"disinfect.elsesa": "andere Fehler",
	"robot.historicaldelete": "Die historischen Daten dieses Roboters werden gelöscht, bestätigen Sie den Löschvorgang?",
	"robot.delfaild": "Löschung fehlgeschlagen",
	"robot.LoRa_ID": "LoRa-Kennung",
	"robot.associatedSIMCard": "Zugehörige SIM-Karte",
	"robot.accumulatedUsageTraffic": "Kumulative Verkehrsnutzung",
	"robot.trafficUsageMonth": "Monatliche Verkehrsnutzung",
	"robot.newrgbd_bottom_depth": "Untere RGBD-Tiefe",
	"robot.batteryTest": "Batterie-Erkennung",
	"robot.Partial_information_update_failed": "Einige Informationen konnten nicht aktualisiert werden",
	"robot.update_failed": "Update fehlgeschlagen",
	"robot.update_robot_datasSuccess": "Erhalten Sie erfolgreich die neuesten Daten des Roboters",
	"ad.waitForDownload": "wartet auf den Download",
	"ad.startDownload": "Starte Download",
	"ad.offLineAndCannotDownload": "Gerät offline, Download nicht möglich",
	"ad.syncing": "Synchronisieren...",
	"robot.robot_does_not_exist": "Roboter existiert nicht",
	"robot.robot_current_enterprise": "Roboter haben das aktuelle Unternehmen verlassen",
	"ad.notEnoughSpace": "Es ist nicht genügend Platz für Unternehmensmaterialien vorhanden. Bitte bereinigen Sie die Dateien rechtzeitig",
	"ad.addAsset": "Material hinzufügen",
	"robot.batteryCommunication": "Batteriekommunikation",
	"disinfect.Thetargetpointisobstacle": "Der Zielpunkt liegt auf einem dynamischen Hindernis",
	"disinfect.Therearenoroadsonadynamicmap": "Auf der dynamischen Karte gibt es keine Straße",
	"robot.buildingRobotErrorTips_10019": "Die Anzahl der Roboter in diesem Geschäft hat die Obergrenze von 16 erreicht. Bitte ändern Sie das Gebäude (Geschäft).",
	"robot.buildingRobotErrorTips_10020": "Fehler beim Generieren von LoraId",
	"map.VirtualWall": "Virtuelle Wand",
	"map.tracks": "Schiene",
	"map.Qrcode": "QR-Code",
	"map.regions": "Bereich",
	"map.anchorpoints": "Positionspunkt",
	"robot.noSearchResults": "keine Suchergebnisse",
	"robot.accountInformationHasBeenModified": "Kontoinformationen wurden geändert",
	"public.tips": "Hinweis",
	"public.agreeWith": "zustimmen",
	"public.iHaveReadAndAgree": "Ich habe gelesen und stimme zu",
	"public.userAgreement": "Nutzungsbedingungen",
	"public.gentle": "Und",
	"public.privacyAgreement": "Datenschutzrichtlinie",
	"public.pleaseAgreeFirst": "Bitte stimmen Sie zuerst zu",
}